import { ShareMetadata } from '@/lib/db/schema';
import { useCallback, useState } from 'react';
import useSWR from 'swr';

export default function useGCSUploader() {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const { data: userInfo } = useSWR('currentUserInfo');

  const gcsUpload = useCallback(
    async (params: Pick<ShareMetadata, 'title' | 'conversationId'> & { file: File }) => {
      const { file, title, conversationId } = params;
      if (!file) return alert('请先选择文件');

      setUploading(true);

      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('title', title);
        formData.append('conversationId', conversationId);
        formData.append('userId', userInfo.id);

        const token = localStorage.getItem('apiAccessToken');

        // 1. 向我们的 API 请求签名 URL
        const res = await fetch('/api/gcs/upload', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
        const { url, shareId, error } = await res.json();
        if (error) throw new Error(error);

        return { url, shareId, error };
      } catch (err) {
        console.error(err);
        setMessage('发生错误: ' + (err instanceof Error ? err.message : String(err)));
        setUploading(false);
      }
    },
    [],
  );

  return { gcsUpload, uploading, message };
}
